import React from "react"
import { Typography } from "@mui/material"
import { getContent } from "components/Disclaimer/components/LanguageToggle"
import { legal_notices_content } from "components/Disclaimer/content/content"
import Button from "@mui/material/Button"
import { DISCLAIMER_TABS } from "components/Disclaimer/Disclaimer"

const LegalNotice = ({ currentLanguage, setDisclaimerOpenTab }) => {
  const contentLanguage = getContent({
    language: currentLanguage,
    content: legal_notices_content,
  })

  return (
    <div>
      <Typography variant={"h3"}>{contentLanguage.copyrights}</Typography>
      <p>
        {contentLanguage.copyright_text}{" "}
        <Button
          style={{ padding: 0, textDecoration: "underline" }}
          onClick={() => setDisclaimerOpenTab(DISCLAIMER_TABS.CREDITS.index)}
          type={"link"}
        >
          {contentLanguage.copyright_link}
        </Button>
      </p>

      <Typography variant={"h3"}>{contentLanguage.trademarks}</Typography>
      <p>{contentLanguage.trademarks_text} </p>

      <Typography variant={"h3"}>{contentLanguage.noLicenses}</Typography>
      <p>{contentLanguage.noLicenses_text}</p>

      <Typography variant={"h3"}>{contentLanguage.productPrices}</Typography>
      <p>{contentLanguage.productPrices_text}</p>

      <Typography variant={"h3"}>{contentLanguage.disclaimer}</Typography>
      <p>{contentLanguage.disclaimer_text}</p>

      <Typography variant={"h3"}>{contentLanguage.dispute}</Typography>
      <p>
        {contentLanguage.dispute_text}{" "}
        <a
          href="http://ec.europa.eu/consumers/odr"
          rel={"noreferrer"}
          target={"_blank"}
        >
          http://ec.europa.eu/consumers/odr
        </a>{" "}
      </p>

      <Typography variant={"h3"}>{contentLanguage.law36}</Typography>
      <p>{contentLanguage.law36_text}</p>

      <Typography variant={"h3"}>{contentLanguage.liability}</Typography>
      <p>{contentLanguage.liability_text}</p>
      <p>{contentLanguage.liability_text2}</p>
    </div>
  )
}
export default LegalNotice
